import { 
    getLeaseFinishedTableList,
    } from "@/apis/company/leaseMgt.js"; 

/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
    set_lease_finished_list: 'bizLeaseFinished/set_lease_finished_list',
    set_lease_finished_total_page: 'bizLeaseFinished/set_lease_finished_total_page',
    set_mode: 'bizLeaseFinished/set_mode',
    set_filter_query: 'bizLeaseFinished/set_filter_query',
    set_filter_word: 'bizLeaseFinished/set_filter_word',
    set_filter_result_total: 'bizLeaseFinished/set_filter_result_total',
    set_filter_default: 'bizLeaseFinished/set_filter_default',
    set_loading: 'bizLeaseFinished/set_loading'

}

// count state 必須是 Object
const state = {
    leaseFinishedList: [],
    totalPage: 0,
    filterQuery: {
        group: '',
        member: '',
        status: '',
        type: '',
        leaseTerm: '',
        county: '',
        district: '',
        rent: [0, 100000],
    },
    filterWord: '',
    filterResultTotal: '',
    mode: null,
    isDefault: true,
    isLoading: false
}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    GET_BIZ_LEASE_FINISHED_MGT_LIST: (state) => {
        return state.leaseFinishedList
    },
    GET_BIZ_LEASE_FINISHED_MGT_TOTAL_PAGE: (state) => {
        return state.totalPage
    },
    GET_BIZ_LEASE_FINISHED_MGT_MODE: (state) => {
        return state.mode
    },
    GET_BIZ_LEASE_FINISHED_MGT_FILTER_QUERY: (state) => {
        return state.filterQuery
    },
    GET_BIZ_LEASE_FINISHED_MGT_FILTER_WORD: (state) => {
        return state.filterWord
    },
    GET_BIZ_LEASE_FINISHED_MGT_FILTER_RESULT_TOTAL: (state) => {
        // console.log(state.filterResultTotal)
        return state.filterResultTotal
    },
    GET_BIZ_LEASE_FINISHED_HOUSE_NAME_IS_EMPTY: (state) => {
        if( state.filterQuery.houseName == null ){
            return true
        }else{
            return false
        }
    },
    GET_BIZ_LEASE_FINISHED_TYPE_IS_EMPTY: (state) => {
        if( state.filterQuery.type == null ){
            return true
        }else{
            return false
        }
    },
    GET_BIZ_LEASE_FINISHED_SOURCE_IS_EMPTY: (state) => {
        if( state.filterQuery.source == null ){
            return true
        }else{
            return false
        }
    },
    GET_BIZ_LEASE_FINISHED_FILTER_WORD_IS_EMPTY: (state) => {
        if( state.filterWord == '' ){
            return true
        }else{
            return false
        }
    },
    GET_BIZ_LEASE_FINISHED_MGT_FILTER_DEFAULT: (state) => {
        return state.isDefault
    },
}

// actions 也是以 Object 形式建構。
const actions = {
    getBizLeaseFinishedMgtList ( {commit}, page = 1 ) {
        return new Promise((resolve, reject) => {
            commit(types.set_loading, true);
            // 抓第一頁前先清空，後續頁碼則累加（保留前端篩選/搜尋邏輯）
            if( page === 1 ){
                commit(types.set_lease_finished_list, null);
            }
            getLeaseFinishedTableList(page)
            .then(res => {
                // console.log(res)
                commit(types.set_loading, false);
                if( res.data.status == "SUCCESS" ){
                    console.log(res)
                    let result = res.data.result
                    // 相容分頁 (Spring Page: content/totalPages) 與未分頁 (純陣列) 兩種回傳
                    let list = Array.isArray(result) ? result : (result.content || [])
                    // 純陣列沒有總頁數資訊 -> 回 0 代表未知，元件改用「抓到空頁為止」策略
                    let totalPage = Array.isArray(result) ? 0 : (result.totalPages || 0)
                    commit(types.set_lease_finished_list, list);
                    commit(types.set_lease_finished_total_page, totalPage);
                    resolve({ count: list.length, totalPage: totalPage })
                }
            })
            .catch(err => {
                reject(err)
            })

        })
    },
    setBizLeaseFinishedFilterQuery ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_query, value);
            resolve()
        })
    },
    setBizLeaseFinishedFilterWord ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_word, value);
            resolve()
        })
    },
    setBizLeaseFinishedFilterResultTotal ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_result_total, value);
            resolve()
        })
    },
    setBizLeaseFinishedFilterDefault ( {commit} ) {
        return new Promise((resolve, reject) => {
            let filter = {
                group: '',
                member: '',
                status: '',
                type: '',
                leaseTerm: '',
                county: '',
                district: '',
                rent: [0, 100000],
            }
            commit(types.set_filter_default, filter);
            resolve()
        })
    },
    // setHouseMgtMode ( {commit}, data ) {
    //     return new Promise((resolve, reject) => {
    //         commit(types.set_mode, data);
    //         resolve()
    //     })
    // }
}

// mutations
const mutations = {
    [types.set_lease_finished_list](state, data){
        // 傳入陣列則累加該頁資料，傳入 null 則清空（抓第一頁前）
        if( data ){
            data.forEach(item => state.leaseFinishedList.push(item))
        }else{
            state.leaseFinishedList = []
        }
    },
    [types.set_lease_finished_total_page](state, data){
        state.totalPage = data
    },
    [types.set_mode](state, data){
        state.mode = data
    },
    [types.set_filter_word](state, data){
        state.filterWord = data
        state.isDefault = false
    },
    [types.set_filter_query](state, data){
        state.filterQuery = data
        state.isDefault = false
    },
    [types.set_filter_result_total](state, data){
        state.filterResultTotal = data
    },
    [types.set_filter_default](state, data){
        state.filterQuery = data
        setTimeout(()=>{
            state.isDefault = true
        },100)
    },
    [types.set_loading](state, data){
        state.isLoading = data
    }
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/bussiness/mgtCategory/leaseMgt/leaseFinished.js